// extracted by mini-css-extract-plugin
export default {"imageWrapper":"tH-z","hovered":"uH-z","hoverImage":"vH-z","mainImage":"wH-z","imageNoBackground":"xH-z","fullSizeImage":"yH-z"};